// extracted by mini-css-extract-plugin
export default {"logs":"Logs_logs__2Q5JB","block":"Logs_block__I0Mps"};